import React from "react";
import Modal from "@/components/controls/Modal";
import { Button } from "@/components/ui/button";
import Text from "@/components/ui/text";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  labels: { title: string; body: string; confirm: string };
}

const ExportTranscriptUnavailableModal: React.FC<Props> = ({
  isOpen,
  onClose,
  labels
}) => {
  return (
    <Modal
      open={isOpen}
      setIsOpen={(open) => {
        if (!open) onClose();
      }}
      contentClassname="w-[30rem]"
      data-test="export-transcript-unavailable-modal"
      title={
        <Text as="div" variant="lgSubtitleH1">
          {labels.title}
        </Text>
      }
      content={
        <div className="flex flex-col gap-2 px-6 pt-4 pb-4">
          <Text variant="body">{labels.body}</Text>
        </div>
      }
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="primary" onClick={onClose}>
            {labels.confirm}
          </Button>
        </div>
      }
    />
  );
};

export default ExportTranscriptUnavailableModal;
